import { basicMsg } from "../../actions/swal_msg";

export const checkUserSession = (msg) => {
    if (['no-token', 'unavailable-token', 'invalid-token'].includes(msg)) {
        basicMsg("Su sesión expiró");
        return false;
    } else return true;
};